import clsx from 'clsx';
import type { LinkListsProps } from './types';
import type { CSSProperties } from 'react';
import { AppLinkList } from './AppLinkList';
import { SoftwareLinkList } from './SoftwareLinkList';

export function SoftwareLinks({ align = 'left', columns = 3, ...props }: LinkListsProps) {
  const customProperties = {
    '--footer-links-list-item-align': align,
  } as CSSProperties;

  return (
    <section className={clsx('footer__links-section', `column-${columns}`)} style={customProperties}>
      <SoftwareLinkList
        align={align}
        flow={props.flow}
        direction={props.direction}
        links={props.downloadSoftware}
        type="software"
        variant="software"
        title={props.constants.i18n_fotowelt_software}
        constants={props.constants}
        addHref={false}
        device={props.device}
      />
      <AppLinkList
        align={align}
        flow={props.flow}
        direction={props.direction}
        links={props.apps}
        type="app"
        variant="software"
        title={props.constants.i18n_pixum_app}
        addHref={false}
        device={props.device}
        initialOperatingSystem={props.initialOperatingSystem}
      />
    </section>
  );
}
